// Removes node FS reference from loki code to avoid webpack warnings
module.exports = null;
